import { FC, useCallback } from 'react';
import { useEventListener } from '@material-bank/ds-utils';
import ReactDOM from 'react-dom/client';

import { useDialogs } from '../../components/DialogsController/hooks';
import { AppProviders } from '../../components/providers/AppProviders';

const EnrichUserProfileDialogController: FC = () => {
  const { openDialog } = useDialogs();

  const openEnrichUserProfileDialog = useCallback(
    (event: CustomEvent) => {
      const { source } = event.detail ?? {};

      openDialog('enrichUserProfile', { source });
    },
    [openDialog],
  );

  useEventListener(
    window,
    'open-enrich-user-profile-dialog',
    openEnrichUserProfileDialog,
  );

  return null;
};

const rootElement = document.getElementById('enrich-user-profile-dialog-root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <AppProviders>
      <EnrichUserProfileDialogController />
    </AppProviders>,
  );
}
